import React from 'react';
import ReactDOM from 'react-dom';
import {App} from '@components/App';

import './scss/main.scss';
import './i18n';

ReactDOM.render(<App/>, document.querySelector('#app'));